/**
 * Allow users to locally save filters in product search
 */
export const ALLOW_SAVING_FILTERS_IN_SEARCH_240415 = 'ALLOW_SAVING_FILTERS_IN_SEARCH_240415';
